import { Paper } from "@mui/material";
import clsx from "clsx";
import { ICON_DARK } from "ds_legacy/materials/colors";
import { border } from "ds_legacy/materials/metrics";
import { ReactNode } from "react";

function MuiCircle({
  children,
  color,
  diameter,
  elevation,
}: {
  children?: ReactNode;
  color?: string;
  diameter?: number;
  elevation?: number;
}) {
  return (
    <Paper
      elevation={elevation ?? 0}
      sx={{
        alignItems: "center",
        backgroundColor: color,
        border: border({ color: color ?? ICON_DARK }),
        borderRadius: "50%",
        cursor: "default",
        display: "flex",
        height: diameter ?? 8,
        justifyContent: "center",
        overflow: "hidden",
        textAlign: "center",
        width: diameter ?? 8,
      }}
    >
      {children}
    </Paper>
  );
}

export function Circle({
  children,
  className,
  color,
  diameter,
  elevation,
}: {
  children?: ReactNode;
  className?: string;
  color?: string;
  diameter?: number;
  elevation?: number;
}) {
  return (
    <div className={clsx("flex justify-center", className)}>
      <MuiCircle color={color} diameter={diameter} elevation={elevation}>
        {children}
      </MuiCircle>
    </div>
  );
}
